'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sticky = require('./sticky');

var _sticky2 = _interopRequireDefault(_sticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _sticky2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-sticky-el/lib/index.js
// module id = 168
// module chunks = 0